import { render, staticRenderFns } from "./registerInputsEditor.vue?vue&type=template&id=6d5fe407&scoped=true&"
import script from "./registerInputsEditor.vue?vue&type=script&lang=js&"
export * from "./registerInputsEditor.vue?vue&type=script&lang=js&"
import style0 from "./registerInputsEditor.vue?vue&type=style&index=0&id=6d5fe407&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5fe407",
  null
  
)

export default component.exports